import { render, staticRenderFns } from "./GoodscatsEdit.vue?vue&type=template&id=dc75c254&scoped=true&"
import script from "./GoodscatsEdit.vue?vue&type=script&lang=js&"
export * from "./GoodscatsEdit.vue?vue&type=script&lang=js&"
import style0 from "./GoodscatsEdit.vue?vue&type=style&index=0&id=dc75c254&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc75c254",
  null
  
)

export default component.exports